module.exports = __webpack_public_path__ + "img/1505586655.8c135677.jpg";